import React from 'react';
import PropTypes from 'prop-types';

import { Spinner } from 'dibs-elements/exports/Spinner';
import styles from './styles/CartLoading.scss';

const CartLoading = ({ isStaticLoading, isUpdating }) => {
    if (isStaticLoading) {
        return (
            <div className={styles.isStatic}>
                <Spinner dark />
            </div>
        );
    } else if (isUpdating) {
        return (
            <div className={`${styles.overlay} ${styles.isUpdate}`}>
                <Spinner dark />
            </div>
        );
    } else {
        return (
            <div className={styles.overlay}>
                <Spinner dark />
            </div>
        );
    }
};

CartLoading.propTypes = {
    isStaticLoading: PropTypes.bool,
    isUpdating: PropTypes.bool,
};

export default CartLoading;
